export default [
  {
    name: 'Нет',
    key: 'no',
  },
  {
    name: 'Центральное',
    key: 'central',
  },
  {
    name: 'Скважина',
    key: 'borehole',
  },
  {
    name: 'Колодец',
    key: 'well',
  },
];
